import {
  TableRelatedDocumentsDtoResponse,
  TableRelatedDocumentsSearchDto,
} from '@asset-metrix/portal-gateway-client-js';
import { QueryFunction } from '@tanstack/react-query';

import { extractErrorMessage } from '../../utils/errorMessage';
import {
  QueryKeyWithRole,
  unwrapQueryKeyWithRole,
} from '../../utils/prependRoleId';
import { HttpError } from '../errors';
import { portalGatewayClient } from '../portalGatewayClient';

const RELATED_DOCUMENTS_LIMIT = 50;

export type DatatableRelatedDocumentsQueryKey = readonly [
  string,
  TableRelatedDocumentsSearchDto['selection'] | undefined,
];

export const fetchDatatableRelatedDocuments: QueryFunction<
  TableRelatedDocumentsDtoResponse,
  QueryKeyWithRole<DatatableRelatedDocumentsQueryKey>
> = async ({ queryKey }) => {
  const [contentId, selection] = unwrapQueryKeyWithRole(queryKey).params;

  const response = await portalGatewayClient.table.searchRelatedDocuments(
    contentId,
    { selection },
    { limit: RELATED_DOCUMENTS_LIMIT }
  );

  if (!response.ok) {
    throw new HttpError(
      extractErrorMessage(response.error, 'Error searching related documents'),
      response
    );
  }

  return response.data;
};
